// extracted by mini-css-extract-plugin
export default {"button":"button_button__VrMyJ","highlighted":"button_highlighted__c1OWH"};